<div class="divider-container">
  <div class="divider"></div>
  <p class="text">
    <ng-content />
  </p>
  <div class="divider"></div>
</div>
